<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" fill="none" viewBox="0 0 20 20">
        <path :fill="color" d="M5.298 14.35h10.148v.044c0 .915-.742 1.656-1.656 1.656H6.954a1.656 1.656 0 0 1-1.656-1.656z" />
        <path :stroke="color" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5" d="M6.973 15.79 4.178 19M13.77 15.79 16.566 19" />
        <path
            :stroke="color"
            stroke-miterlimit="10"
            stroke-width="1.5"
            d="M5.044 17.728H15.7M7.955 2.44h4.853c1.322 0 2.45 1.043 2.665 2.467l1.223 6.496c.271 1.796-.998 3.428-2.666 3.428H6.712c-1.671 0-2.942-1.64-2.664-3.439l1.243-6.494c.22-1.42 1.346-2.459 2.664-2.459z"
        />
        <path
            :fill="color"
            d="M13.252 2.7H7.49v-.044C7.49 1.742 8.232 1 9.146 1h2.45c.915 0 1.656.742 1.656 1.656zM7.241 13.086a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2M13.521 13.086a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2M4.467 9.538h11.812l-.562-4.788H5.385z"
        />
        <path :stroke="color" stroke-miterlimit="10" stroke-width="1.5" d="M10.373 4.438v5.1" />
    </svg>
</template>

<script>
export default {
    name: 'TrainSVG',
    props: {
        color: {
            type: String,
            default: 'black'
        },
        width: {
            type: String,
            default: '34'
        },
        height: {
            type: String,
            default: '20'
        }
    },
}
</script>
